import { CONNECTED_SOCKET, SUBSCRIBE, UNSUBSCRIBE, LIVE_MESSAGE, UPDATE_LIVE_DATA_SHOW } from '../constants/action-types';

const initialState = {
    isConnected: false,
    messageList: []
}

export default (state = initialState, action) => {
    switch (action.type) {
        case CONNECTED_SOCKET:
            state = { ...state, isConnected: action.isConnected };
            break;
        case SUBSCRIBE:
            if (!action.trackMessages) break;
            // state = { ...state, messageList: addMessage(state.messageList, action) };
            break;
        case UNSUBSCRIBE:
            if (!action.clearMessages) break;
            // state = { ...state, messageList: removeMessage(state.messageList, action) };
            break;
        case LIVE_MESSAGE:
            // const messageList = state.messageList;
            // const live = action.message;
            // if (messageList[live.deviceId] && messageList[live.deviceId][live.name])
            //     messageList[live.deviceId][live.name].message = live.message;
            const live = action.message

            state = { ...state, messageList: [...state.messageList, { ...live, isDataShow: true }] };
            break;
        case UPDATE_LIVE_DATA_SHOW:
            state = { ...state, messageList: state.messageList.map(item => ({ ...item, isDataShow: false })) };
            break;
        default:
            break;
    }

    return state;
}

// const addMessage = (messageList, action) => {
//     const notifications = (!Array.isArray(action.notifications) && typeof action.notifications === 'object') ?
//         [action.notifications] : action.notifications;

//     if (Array.isArray(notifications)) {
//         messageList = removeMessage(messageList, action);
//         notifications.forEach(e => {
//             if (!(e.hasOwnProperty('deviceId') && e.hasOwnProperty('name'))) return;
//             if (!messageList.hasOwnProperty(e.deviceId)) messageList[e.deviceId] = {};
//             if (!messageList[e.deviceId].hasOwnProperty(e.name)) messageList[e.deviceId][e.name] = { message: null, groups: [] };
//             if (messageList[e.deviceId][e.name].groups.indexOf(action.group) < 0)
//                 messageList[e.deviceId][e.name].groups.push(action.group);
//         }, this);
//     }

//     return messageList;
// }

// const removeMessage = (messageList, action) => {
//     for (let deviceId of Object.keys(messageList)) {
//         for (let name of Object.keys(messageList[deviceId])) {
//             const indexOf = messageList[deviceId][name].groups.indexOf(action.group);
//             if (indexOf === 0) delete messageList[deviceId][name];
//             else if (indexOf >= 0)
//                 delete messageList[deviceId][name].groups.splice(indexOf, 1);
//         }

//         if (Object.keys(messageList[deviceId]).length === 0) delete messageList[deviceId];
//     }

//     return messageList;
// }